var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeSvgform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 5,
    fill: "#FF5E15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.5C27.7019 12.5 25.4262 12.9527 23.303 13.8321C21.1798 14.7116 19.2507 16.0006 17.6256 17.6256C14.3437 20.9075 12.5 25.3587 12.5 30C12.5 34.6413 14.3437 39.0925 17.6256 42.3744C19.2507 43.9994 21.1798 45.2884 23.303 46.1679C25.4262 47.0474 27.7019 47.5 30 47.5C34.6413 47.5 39.0925 45.6563 42.3744 42.3744C45.6563 39.0925 47.5 34.6413 47.5 30C47.5 27.7019 47.0474 25.4262 46.1679 23.303C45.2884 21.1798 43.9994 19.2507 42.3744 17.6256C40.7493 16.0006 38.8202 14.7116 36.697 13.8321C34.5738 12.9527 32.2981 12.5 30 12.5ZM37.35 37.35L28.25 31.75V21.25H30.875V30.35L38.75 35.075L37.35 37.35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeSvgform);
export default __webpack_public_path__ + "static/media/office_svgform.2bf9403d130c68c8420fbe099add75f8.svg";
export { ForwardRef as ReactComponent };